/// <amd-module name="Repos/Views/PullRequest/RestClient/Policy" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\pr-details\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as TFS_Policy_Contracts from "Repos/Common/Contracts/Policy";

export interface IPolicyRestClient extends IVssRestClient {
    /**
     * Requeue the policy evaluation.
     * 
     * @param project - Project ID or project name
     * @param evaluationId - ID of the policy evaluation to be retrieved.
     */
    requeuePolicyEvaluation(project: string, evaluationId: string): Promise<TFS_Policy_Contracts.PolicyEvaluationRecord>;
}

class PolicyRestClient extends RestClientBase implements IPolicyRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Requeue the policy evaluation.
     * 
     * @param project - Project ID or project name
     * @param evaluationId - ID of the policy evaluation to be retrieved.
     */
    public async requeuePolicyEvaluation(
        project: string,
        evaluationId: string
        ): Promise<TFS_Policy_Contracts.PolicyEvaluationRecord> {

        return this.beginRequest<TFS_Policy_Contracts.PolicyEvaluationRecord>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/policy/Evaluations/{evaluationId}",
            routeValues: {
                project: project,
                evaluationId: evaluationId
            }
        });
    }

}

export const PolicyClientName = "Repos.PRDetails.Policy.IPolicyRestClient";

export function getPolicyClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPolicyRestClient {
    return pageContext.getRestClient<IPolicyRestClient>(PolicyClientName, options);
}

RestClients.add(PolicyClientName, { 
    factory: PolicyRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
